import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import ResizeObserver from 'resize-observer-polyfill';

/**
 * 內容自動收合元件
 *
 * @export
 * @class CollapsibleContentContainerComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 * @implements {OnDestroy}
 * @description
 * 此為通則規定在內容顯示兩行以上時，只顯示部分內容，待點擊 more 展開完整內容
 */
@Component({
  selector: 'sigv-collapsible-content-container',
  templateUrl: './collapsible-content-container.component.html',
  styleUrls: ['./collapsible-content-container.component.scss'],
})
export class CollapsibleContentContainerComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  /**
   * 文字收合時顯示的行數，預設值為 2
   */
  @Input() line = 2;

  /**
   * 原始內容容器(用來計算寬度是否超過)
   */
  @ViewChild('content') content!: ElementRef;
  @ContentChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
  contentTemplate!: TemplateRef<any>;
  showCollapse = false;
  collapsed = true;
  resizeObserver = new ResizeObserver(() => {
    this.onContentChange();
  });

  constructor(private cd: ChangeDetectorRef) {}

  //#region Angular lifecycle hooks
  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'content':
          this.contentTemplate = item.template;
          break;
        default:
          break;
      }
    });

    this.resizeObserver.observe(this.content.nativeElement);
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.resizeObserver.unobserve(this.content.nativeElement);
    this.resizeObserver.disconnect();
  }
  //#endregion Angular lifecycle hooks

  //#region Event callback
  /**
   * div click 事件
   *
   * @memberof CollapsibleContentContainerComponent
   */
  onContainerClick(): void {
    if (this.showCollapse) {
      this.collapsed = !this.collapsed;
    }
  }

  /**
   * 內容異動事件
   *
   * @private
   * @memberof CollapsibleContentContainerComponent
   */
  private onContentChange(): void {
    this.calculateCollapsibleContainer();
  }
  //#endregion Event callback

  /**
   * 計算是否要呈現收合狀態
   *
   * @private
   * @memberof CollapsibleContentContainerComponent
   */
  private calculateCollapsibleContainer(): void {
    if (!this.showCollapse) {
      const el = this.content.nativeElement as HTMLElement;
      this.showCollapse = el.scrollHeight > el.offsetHeight;
    }
  }
}
